import React, { useEffect, useState } from "react";
import { PageHeader } from "../components/Layout";
import { WifiBadge } from "../components/StatusBadge";
import { api } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n/I18nContext";
import { toast } from "sonner";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { MoreHorizontal } from "lucide-react";

export default function WifiUsers() {
  const { t } = useI18n();
  const { effectiveStructure } = useAuth();
  const [items, setItems] = useState([]);

  const load = () => {
    const p = effectiveStructure ? `?structure_id=${effectiveStructure}` : "";
    api.get(`/users${p}`).then((r) => setItems(r.data));
  };
  useEffect(() => { load(); }, [effectiveStructure]);

  const setStatus = async (u, status) => {
    await api.put(`/users/${u.id}/status`, { status });
    toast.success("✓"); load();
  };

  return (
    <div data-testid="users-page">
      <PageHeader title={t("users.title")} subtitle={t("res.rule")} />
      <div className="rounded-xl border border-[#1F2937] bg-[#111827] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-[#1F2937]">
                <th className="px-4 py-3">{t("users.username")}</th>
                <th className="px-4 py-3">{t("res.guest")}</th>
                <th className="px-4 py-3">{t("users.profile")}</th>
                <th className="px-4 py-3">{t("users.devices")}</th>
                <th className="px-4 py-3">{t("common.status")}</th>
                <th className="px-4 py-3 text-right">{t("common.actions")}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((u) => (
                <tr key={u.id} data-testid={`user-row-${u.id}`} className="border-b border-[#1F2937]/60 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 font-mono font-semibold text-cyan-400">{u.username}</td>
                  <td className="px-4 py-3">{u.guest_name}</td>
                  <td className="px-4 py-3 text-slate-400">{u.profile_name}</td>
                  <td className="px-4 py-3 text-slate-400">{u.max_devices}</td>
                  <td className="px-4 py-3"><WifiBadge status={u.status} live={u.status === "active"} /></td>
                  <td className="px-4 py-3 text-right">
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <button data-testid={`user-actions-${u.id}`} className="p-1.5 rounded-md hover:bg-white/5 text-slate-400"><MoreHorizontal className="h-4 w-4" /></button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end" className="bg-[#111827] border-[#1F2937] text-slate-100">
                        <DropdownMenuItem data-testid={`user-activate-${u.id}`} onClick={() => setStatus(u, "active")} className="cursor-pointer focus:bg-white/5 text-emerald-400">{t("wifi.active")}</DropdownMenuItem>
                        <DropdownMenuItem data-testid={`user-suspend-${u.id}`} onClick={() => setStatus(u, "suspended")} className="cursor-pointer focus:bg-white/5 text-orange-400">{t("wifi.suspended")}</DropdownMenuItem>
                        <DropdownMenuItem data-testid={`user-disable-${u.id}`} onClick={() => setStatus(u, "disabled")} className="cursor-pointer focus:bg-white/5 text-rose-400">{t("wifi.disabled")}</DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">{t("common.none")}</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
